import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAccess } from "../context/AccessContext";
import "../css/AccessManagement.css";
import { NO_ACCESS_PATH, getHomePath } from "../utils/routeAccess";
import Layout from "./Layout";

/** 접근 가능한 메뉴가 하나도 없는 어드민에게 보여주는 화면 (spec R-FE-05) */
function NoAccess() {
  const navigate = useNavigate();
  const { hasPermission, refreshAccess } = useAccess();
  const [checking, setChecking] = useState(false);

  // 권한이 생기면(포커스 재조회 등) 첫 메뉴로 이동
  useEffect(() => {
    const home = getHomePath(hasPermission);
    if (home !== NO_ACCESS_PATH) navigate(home, { replace: true });
  }, [hasPermission, navigate]);

  const handleRecheck = async () => {
    setChecking(true);
    try {
      await refreshAccess();
    } finally {
      setChecking(false);
    }
  };

  return (
    <Layout>
      <div className="access-page">
        <div className="access-section access-empty" data-testid="no-access">
          <h4 className="access-page-title">권한 없음</h4>
          <p className="access-page-desc" style={{ marginTop: 12 }}>
            이 계정에는 사용할 수 있는 메뉴가 없습니다.
            <br />
            권한 관리자에게 필요한 권한(역할)을 요청해 주세요.
          </p>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            style={{ marginTop: 12 }}
            onClick={handleRecheck}
            disabled={checking}
          >
            {checking ? "확인 중..." : "권한 다시 확인"}
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default NoAccess;
